var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12866)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.765 11.241C18.5578 11.241 18.39 11.0732 18.39 10.866V3.39479C18.39 3.18759 18.5578 3.01978 18.765 3.01978C18.9722 3.01978 19.14 3.18759 19.14 3.39479V10.866C19.14 11.0732 18.9722 11.241 18.765 11.241Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.686 8.16206C16.8042 8.16206 16.9214 8.21831 16.9945 8.32332L18.7646 10.8686L20.5346 8.32332C20.6527 8.15363 20.8871 8.11144 21.0568 8.22957C21.2265 8.34769 21.2687 8.58113 21.1506 8.75177L19.0721 11.7396C19.0017 11.8409 18.8874 11.9009 18.7646 11.9009C18.6417 11.9009 18.5264 11.8409 18.4571 11.7396L16.3786 8.75177C16.2604 8.58208 16.3026 8.3477 16.4723 8.22957C16.5379 8.18456 16.612 8.16206 16.686 8.16206Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4205 24.4282C9.73727 24.4282 7.5556 22.2456 7.5556 19.5633C7.5556 17.9704 8.3225 16.4993 9.61818 15.5864V3.23151C9.61818 1.68552 10.8754 0.428223 12.4215 0.428223C13.9674 0.428223 15.2247 1.68545 15.2247 3.23151V15.5864C16.5195 16.4995 17.2873 17.9705 17.2873 19.5633C17.2873 22.2456 15.1047 24.4282 12.4217 24.4282H12.4205ZM12.4205 1.17849C11.288 1.17849 10.3674 2.09913 10.3674 3.23167V15.7862C10.3674 15.9137 10.3027 16.0328 10.1958 16.1012C9.01263 16.8634 8.30574 18.1582 8.30574 19.5636C8.30574 21.8324 10.1517 23.6785 12.4214 23.6785C14.6902 23.6785 16.537 21.8325 16.537 19.5636C16.537 18.1582 15.8301 16.8635 14.647 16.1012C14.5401 16.0318 14.4754 15.9137 14.4754 15.7862V3.23263C14.4754 2.10105 13.5548 1.17945 12.4222 1.17945L12.4205 1.17849Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.421 21.867C11.1507 21.867 10.1166 20.8329 10.1166 19.5625C10.1166 18.2922 11.1507 17.2581 12.421 17.2581C13.6914 17.2581 14.7255 18.2922 14.7255 19.5625C14.7255 20.8329 13.6914 21.867 12.421 21.867ZM12.421 18.0081C11.5641 18.0081 10.8666 18.7056 10.8666 19.5626C10.8666 20.4195 11.5641 21.117 12.421 21.117C13.2779 21.117 13.9755 20.4195 13.9755 19.5626C13.9755 18.7057 13.278 18.0081 12.421 18.0081Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4206 18.0093C12.2134 18.0093 12.0456 17.8415 12.0456 17.6343V3.33131C12.0456 3.12412 12.2134 2.9563 12.4206 2.9563C12.6278 2.9563 12.7956 3.12412 12.7956 3.33131V17.6343C12.7956 17.8415 12.6278 18.0093 12.4206 18.0093Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00077 17.2826C5.79358 17.2826 5.62576 17.1148 5.62576 16.9076V0.895519C5.62576 0.688326 5.79358 0.520508 6.00077 0.520508C6.20797 0.520508 6.37579 0.688326 6.37579 0.895519V16.9076C6.37579 17.1148 6.20797 17.2826 6.00077 17.2826Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00064 3.00491H2.08924C1.88205 3.00491 1.71423 2.83709 1.71423 2.62989C1.71423 2.4227 1.88205 2.25488 2.08924 2.25488H6.00064C6.20784 2.25488 6.37565 2.4227 6.37565 2.62989C6.37565 2.83709 6.20784 3.00491 6.00064 3.00491Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00064 6.59084H2.08924C1.88205 6.59084 1.71423 6.42302 1.71423 6.21583C1.71423 6.00864 1.88205 5.84082 2.08924 5.84082H6.00064C6.20784 5.84082 6.37565 6.00864 6.37565 6.21583C6.37565 6.42302 6.20784 6.59084 6.00064 6.59084Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00064 10.1751H2.08924C1.88205 10.1751 1.71423 10.0073 1.71423 9.80006C1.71423 9.59287 1.88205 9.42505 2.08924 9.42505H6.00064C6.20784 9.42505 6.37565 9.59287 6.37565 9.80006C6.37565 10.0073 6.20784 10.1751 6.00064 10.1751Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00064 13.7576H2.08924C1.88205 13.7576 1.71423 13.5898 1.71423 13.3826C1.71423 13.1754 1.88205 13.0076 2.08924 13.0076H6.00064C6.20784 13.0076 6.37565 13.1754 6.37565 13.3826C6.37565 13.5898 6.20784 13.7576 6.00064 13.7576Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 4.79787H3.40425C3.19705 4.79787 3.02924 4.63006 3.02924 4.42286C3.02924 4.21567 3.19705 4.04785 3.40425 4.04785H6.00016C6.20736 4.04785 6.37518 4.21567 6.37518 4.42286C6.37518 4.63006 6.20736 4.79787 6.00016 4.79787Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 8.38039H3.40425C3.19705 8.38039 3.02924 8.21258 3.02924 8.00538C3.02924 7.79819 3.19705 7.63037 3.40425 7.63037H6.00016C6.20736 7.63037 6.37518 7.79819 6.37518 8.00538C6.37518 8.21258 6.20736 8.38039 6.00016 8.38039Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 11.9663H3.40425C3.19705 11.9663 3.02924 11.7985 3.02924 11.5913C3.02924 11.3841 3.19705 11.2163 3.40425 11.2163H6.00016C6.20736 11.2163 6.37518 11.3841 6.37518 11.5913C6.37518 11.7985 6.20736 11.9663 6.00016 11.9663Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 15.5489H3.40425C3.19705 15.5489 3.02924 15.381 3.02924 15.1738C3.02924 14.9666 3.19705 14.7988 3.40425 14.7988H6.00016C6.20736 14.7988 6.37518 14.9666 6.37518 15.1738C6.37518 15.381 6.20736 15.5489 6.00016 15.5489Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6481 3.08183C16.0715 3.08183 15.6018 2.61214 15.6018 2.03555C15.6018 1.45898 16.0715 0.989258 16.6481 0.989258C17.2247 0.989258 17.6944 1.45895 17.6944 2.03555C17.6944 2.61211 17.2247 3.08183 16.6481 3.08183ZM16.6481 1.73928C16.4849 1.73928 16.3518 1.87241 16.3518 2.03555C16.3518 2.19868 16.4849 2.33181 16.6481 2.33181C16.8112 2.33181 16.9443 2.19868 16.9443 2.03555C16.9443 1.87241 16.8112 1.73928 16.6481 1.73928Z",
    fill: "#564AB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#564AB3",
    transform: "translate(0 0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureMin);
export default __webpack_public_path__ + "static/media/TemperatureMin.5aa1a4de2adbfbc7e993a6a7c973229c.svg";
export { ForwardRef as ReactComponent };